import { gql } from 'apollo-angular';

const GET_PLAN_IMPACT_SELLER_PARTNER_VIEW = gql`
  query GetPlanImpact(
    $rfpId: Long!
    $offerId: Long!
    $primaryCrosses: Boolean
    $memberId: Long
    $tierId: Long
  ) {
    planImpact(
      rfpId: $rfpId
      offerId: $offerId
      primaryCrosses: $primaryCrosses
      memberId: $memberId
      tierId: $tierId
    ) {
      offer {
        id
        name
        unorderedTiers
  			unorderedPricing
        seller {
          name
        }
        tiers {
          id
          name
          description
          cpaId
          order
          allowedPartnerIds
          dollarMarketShare
          unitMarketShare
          absoluteDollars
          absoluteUnits
          spendLevelType
          tierType
          active
        }
      }
      plannedSpendLevel
      attainability
      selectedTier {
        id
        name
        description
        cpaId
        order
        allowedPartnerIds
        dollarMarketShare
        unitMarketShare
        absoluteDollars
        absoluteUnits
        spendLevelType
        tierType
        active
      }
      planImpacts {
        member {
          id
          name
          address {
            city
            state
          }
        }
        planId
        results {
          savingsAmount
          savingsPct
          plannedSpend
          continuedSpend
          conversionsCount {
            totalConversionsCount
          }
          numberOfIncumbents
          excludedPlannedSpend
          compliancePlannedSpend
        }
      }
    }
  }
`;

export default GET_PLAN_IMPACT_SELLER_PARTNER_VIEW;
